import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRouteSnapshot, RouterLink } from '@angular/router';

/** A route declares which report/list filters are meaningful at its entry root. */
export function rootBreadcrumbQueryParams(route: Pick<ActivatedRouteSnapshot, 'data' | 'queryParamMap'>): Record<string, string> {
  const keys: unknown = route.data['breadcrumbRootQueryParams'];
  if (!Array.isArray(keys)) return {};
  return Object.fromEntries(keys.filter((key): key is string => typeof key === 'string')
    .filter(key => route.queryParamMap.has(key)).map(key => [key, route.queryParamMap.get(key)!]));
}

/** A Workspace navigation link; Files also includes its current directory. */
export interface WorkspaceBreadcrumb {
  label: string;
  path: string;
  queryParams?: Record<string, string>;
}

@Component({
  selector: 'app-workspace-breadcrumbs',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './workspace-breadcrumbs.component.html',
  styleUrls: ['./workspace-breadcrumbs.component.css'],
})
export class WorkspaceBreadcrumbsComponent {
  @Input() breadcrumbs: WorkspaceBreadcrumb[] = [];
  @Input() label = 'Breadcrumb';
  @Input() trailingSeparator = false;
  /** Callers may rebuild crumbs each pass; positions keep their links and only bindings update. */
  readonly trackPosition = (index: number): number => index;
}
